import { User } from '../contexts/types';
import formatter from '../utils/formatter';

/* eslint-disable @typescript-eslint/no-explicit-any */
declare global {
  interface Window {
    analytics: any;
  }
}
/* eslint-enable @typescript-eslint/no-explicit-any */

class Analytics {
  timers: Record<string, number> = {};
  identify(user: User) {
    const { ref, name, email, userType, phone, phoneCc } = user;
    if (window.analytics) {
      window.analytics.identify(ref, {
        name,
        email,
        phone: phone && phoneCc ? formatter.phone(phone, phoneCc) : '',
        type: userType === 'business' ? 'business' : 'consumer',
      });
    }
  }

  reset() {
    if (window.analytics) {
      window.analytics.reset();
    }
  }

  event(name: string, properties = {}) {
    if (window.analytics) {
      window.analytics.track(name, properties);
    }
  }

  page() {
    if (window.analytics) {
      window.analytics.page();
    }
  }

  setEventTimer(eventName: string, timestamp: number) {
    this.timers[eventName] = timestamp;
  }

  removeEventTimer(eventName: string): number {
    const timestamp = this.timers[eventName];
    if (!!timestamp) {
      delete this.timers[eventName];
    }
    return timestamp;
  }
}

export default new Analytics();
